//React
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import Constants from "../../Context/constants";
import Helpers from "../../Context/helpers";

//Ionic
import {
  IonCard,
  IonBadge,
  IonGrid,
  IonRow,
  IonCol,
  IonIcon,
} from "@ionic/react";
import {
  locationSharp,
  bookmarkOutline,
  bookmark,
  ticket,
} from "ionicons/icons";

function showModal(id) {
  window.openid = id;
  document.getElementById("openmodal").click();
}

function InfoCard(props) {
  // diese Zeile löschen, damit die Speaking URLs wieder funktionieren
  //props.slug = props.id;
  const [interestBadge, setInterestBadge] = useState(false);
  const [hasTourenData, setHasTourenData] = useState(false);

  useEffect(() => {
    /* Check if Profile Interests are part of pitch */

    function checkInterests() {

      props.interests.map((item) => {
        if (item === "Genuss") {
          if (["restaurant", "vintner", "brewery"].includes(props.category)) {
            setInterestBadge(true);
            return true;
          }
          if (props.subcategories.length !== 0) {
            if (
              props.subcategories.subcategory.some((category) =>
                ["restaurant", "vintner", "brewery"].includes(category)
              )
            ) {
              setInterestBadge(true);
              return true;
            }
          }
          if (props.interesttags.length !== 0) {
            let searchItemsGenuss = ["Genuss","Völlerei","Kulinarik"];
            if (
              // search if interesttags.tag contains "Genuss", the items are objects with name property
              props.interesttags.tag.some((item) => searchItemsGenuss.includes(item.name))
            ) {
              setInterestBadge(true);
              return true;
            }
          }
        } else if (item === "Wellness & Gesundheit") {
          if (["thermal_bath"].includes(props.category)) {
            setInterestBadge(true);
            return true;
          }
          if (props.subcategories.length !== 0) {
            if (
              props.subcategories.subcategory.some((category) =>
                ["thermal_bath"].includes(category)
              )
            ) {
              setInterestBadge(true);
              return true;
            }
          }
          if (props.interesttags.length !== 0) {
            let searchItemsWellness = ["Thermen","Wellness","Kur"];
            if (
              props.interesttags.tag.some((item) => searchItemsWellness.includes(item.name))
            ) {
              setInterestBadge(true);
              return true;
            }
          }
        } else if (item === "Kultur & Geschichte") {
          if (["castle", "museum"].includes(props.category)) {
            setInterestBadge(true);
            return true;
          }
          if (props.subcategories.length !== 0) {
            if (
              props.subcategories.subcategory.some((category) =>
                ["castle", "museum"].includes(category)
              )
            ) {
              setInterestBadge(true);
              return true;
            }
          }
          if (props.interesttags.length !== 0) {
            let searchItemsKultur = ["Städte","Kultur"];
            if (
              props.interesttags.tag.some((item) => searchItemsKultur.includes(item.name))
            ) {
              setInterestBadge(true);
              return true;
            }
          }
        } else if (item === "Schwimmen & Baden") {
          if (["water_park", "lake"].includes(props.category)) {
            setInterestBadge(true);
            return true;
          }
          if (props.subcategories.length !== 0) {
            if (
              props.subcategories.subcategory.some((category) =>
                ["water_park", "lake"].includes(category)
              )
            ) {
              setInterestBadge(true);
              return true;
            }
          }
          if (props.interesttags.length !== 0) {
            let searchItemsBaden = ["Badesee","Meer","Atlantik","Mittelmeer","Nordsee","Ostsee","Baden/Schwimmen"];
            if (
              props.interesttags.tag.some((item) => searchItemsBaden.includes(item.name))
            ) {
              setInterestBadge(true);
              return true;
            }
          }
        } else if (item === "Sport & Spaß") {
          if (
            [
              "funicular",
              "ski_lift",
              "golf_course",
              "amusement_park",
              "marina",
            ].includes(props.category)
          ) {
            setInterestBadge(true);
            return true;
          }
          if (props.subcategories.length !== 0) {
            if (
              props.subcategories.subcategory.some((category) =>
                [
                  "funicular",
                  "ski_lift",
                  "golf_course",
                  "amusement_park",
                  "marina",
                ].includes(category)
              )
            ) {
              setInterestBadge(true);
              return true;
            }
          }
          if (props.interesttags.length !== 0) {
            let searchItemsSpass = ["Golfen","Freizeitparks","Angeln","Klettern","Radfahren","Mountainbiking","Wandern","Wasssersport","Wintersport","Sport"];
            if (
              props.interesttags.tag.some((item) => searchItemsSpass.includes(item.name))
            ) {
              setInterestBadge(true);
              return true;
            }
          }
        } else if (item === "Naturnah übernachten") {
          if (["farm", "nature_park"].includes(props.category)) {
            setInterestBadge(true);
            return true;
          }
          if (props.subcategories.length !== 0) {
            if (
              props.subcategories.subcategory.some((category) =>
                ["farm", "nature_park"].includes(category)
              )
            ) {
              setInterestBadge(true);
              return true;
            }
          }
          if (props.interesttags.length !== 0) {
            let searchItemsNatur = ["Naturpark","Im Grünen","Naturnah","Fluss"];
            if (
              props.interesttags.tag.some((item) => searchItemsNatur.includes(item.name))
            ) {
              setInterestBadge(true);
              return true;
            }
          }
        }
      });
    }
    checkInterests();
  }, []);

  function decode(str) {
    let txt = document.createElement("div");
    txt.innerHTML = str;
    var realtext = txt.innerText.replaceAll("&nbsp;", "\u00A0");
    return realtext;
  }

  // Voucher
  let foundValidVoucher = false;

  // Date
  var date = new Date();
  var currentDay = String(date.getDate()).padStart(2, "0");
  var currentMonth = String(date.getMonth() + 1).padStart(2, "0");
  var currentYear = date.getFullYear();

  let today = currentYear + "-" + currentMonth + "-" + currentDay;

  // Slice the string of Stellplatzlänge and Preis on Load
  if (
    typeof props.stellplaetzeLaenge !== "undefined" &&
    props.stellplaetzeLaenge !== null &&
    props.stellplaetzeLaenge.length > 2
  ) {
    if (props.stellplaetzeLaenge.substring(1, 2) === ".") {
      var stellplaetzeLaenge = props.stellplaetzeLaenge.substring(0, 1);
    } else {
      var stellplaetzeLaenge = props.stellplaetzeLaenge.substring(0, 2);
    }
  }
  if (typeof props.vergleichspreis !== "undefined") {
    if (props.vergleichspreis == 0) {
      var vergleichspreis = "Gratis";
    } else {
      vergleichspreis =
        Helpers.formatNumberString(props.vergleichspreis) + " " + props.preiseWaehrung;
    }
  }

  function highlightMarker(item) {
    var elements = document.querySelector(`[title*="${item}"]`);
    elements.style.backgroundImage =
      "url(/wp-content/uploads/2023/06/MarkerRed.png";
    elements.style.backgroundRepeat = "no-repeat";
  }

  function unhighlightMarker(item) {
    var elements = document.querySelector(`[title*="${item}"]`);
    elements.style.backgroundImage = "none";
  }

  var target = decode(props.name);

  return (
    <div
      data-icon-id={props.id}
      className="container"
      data-fav={props.fav}
      lang="de"
    >
      {props.stellplatztyp === "Stellplatz" ||
      props.stellplatztyp === "Stellplatz mit Entsorgungsstation" ? (
        <IonCard
          key={props.id}
          color="light"
          className="infocard__cardwrapper"
          id={props.id}
          onMouseEnter={() => highlightMarker(props.id)}
          onMouseLeave={() => unhighlightMarker(props.id)}
        >
          {window.location.href.indexOf("typ=Entsorgungsstation") === -1 &&  target.indexOf("Eigenes Ziel: ") === -1 && (
              <>
                <a onClick={() => showModal(props.id)} className="infocard__bookmark">
                  <IonIcon
                      className="bookmark_active"
                      size="lg"
                      icon={bookmark}
                      color="medium"
                  />
                </a>
                <a onClick={() => showModal(props.id)} className="infocard__bookmark">
                  <IonIcon
                      className="bookmark_inactive"
                      size="lg"
                      icon={bookmarkOutline}
                      color="medium"
                  />
                </a>
              </>
          )}
          <Link
            target={`${
              window.location.hash == "#nosearch" ? "_blank" : "_self"
            }`}
            to={`${
              window.location.hash == "#nosearch"
                ? "/stellplatz/"
                : "/map/pitch/"
            }${props.slug}`}
          >
            <div className="container">
              <div className="row">
                {props.url === "" ? (
                  <div 
                    className="col col-4 infocard__background__image"
                  ><img src="/wp-content/uploads/2023/04/Symbolbild1_c_Hardy-Mutschler_Muster.jpg" class="infocard__background__image" /></div>
                ) : (
                  <div
                    className="col col-4 infocard__background__image"
                  ><img src={props.url} class="infocard__background__image" /></div>
                )}

                <div size="8" className="col col-8 infocard__content">
                  {props.premium === "1" && (
                    <IonBadge
                      className="infocard__badge premium"
                      color="tertiary"
                    >
                      Premium-Stellplatz
                    </IonBadge>
                  )}
                  {interestBadge && (
                    <IonBadge
                      className="infocard__badge premium"
                      color="tertiary"
                    >
                      Entspricht deinen Interessen
                    </IonBadge>
                  )}
                  <h4 className="h4__bitter infocard__title">
                    {decode(props.name)}<br />
                    <span
                      className={`font__icon infocard__icon_category ${Constants.categoryFontMapping[props.category]}`}
                    >
                      {Constants.categoryFontMapping[props.category]}
                    </span>
                  </h4>
                </div>
                <div className="col col-12 infocard__content">
                  <div className="infocard__icons">
                    {props.ausstattung !== undefined &&
                      props.ausstattung.map((item) => {
                        if (
                          item.featureIcon === "n" ||
                          item.featureIcon === "q" ||
                          item.featureIcon === "l" ||
                          item.featureIcon === "k" ||
                          item.featureIcon === "h" ||
                          item.featureIcon === "f" ||
                          item.featureIcon === "z" ||
                          item.featureIcon === "u"
                        ) {
                          return (
                            <span
                              className={`font__icon infocard__icon ${item.featureIcon}`}
                            >
                              {item.featureIcon}
                            </span>
                          );
                        }
                      })}
                  </div>

                  {(window.location.hostname === "woodstock.local" || window.location.hostname === "dev3.bordatlas.de") && (
                    <div className="container padding__none">
                      <div className="row padding__none">
                        <div
                          className="col col-12 padding__none infocard__wrapper__distance"
                        >
                          Kategorie: {props.category}<br />
                          {
                            props.subcategories.subcategory !== undefined ? (
                              <>Unterkategorien: {props.subcategories.subcategory.join(", ")}<br /></>
                            ) : (
                              <>Keine Unterkategorien<br /></>
                            )
                          }

                          {
                            props.interesttags.tag !== undefined ? (
                              <>Tags: {props.interesttags.tag.map((item) => item.name).join(", ")}<br /></>
                            ) : (
                              <>Keine Tags<br /></>
                            )
                          }
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="container padding__none">
                    <div className="row padding__none">
                      <div
                        className="col col-6 padding__none infocard__wrapper__distance"
                      >
                        <h5 className="h5_bitter infocard__heading">
                          {props.city}, {props.country}
                          {props.responseType === "default" && (
                            <>
                              <br />
                              <IonIcon icon={locationSharp} color="primary" />
                              {props.distance} km
                            </>
                          )}
                        </h5>
                      </div>
                      <div 
                        className="col col-6 padding__none ion-text-end infocard__wrapper__badges"
                      >
                        {typeof props.stellplaetzeLaenge !== undefined &&
                          props.stellplaetzeLaenge !== null && (
                            <IonBadge
                              color="secondary"
                              className="infocard__badge__margin"
                            >
                              &lt; {props.stellplaetzeLaenge} m
                            </IonBadge>
                          )}{" "}
                        {props.vergleichspreis !== undefined && (
                          <IonBadge
                            color="secondary"
                            className="infocard__badge__margin"
                          >
                            {vergleichspreis}
                          </IonBadge>
                        )}{" "}
                        {props.voucher !== undefined &&
                          props.voucher.forEach((item) => {
                            item.dateranges.daterange.map((items) => {
                              if (today <= items.validUntil) {
                                foundValidVoucher = true;
                              }
                            });
                          })}
                        {foundValidVoucher && (
                          <>
                            <IonBadge
                              color="primary"
                              className="infocard__badge__margin infocard__badge__voucher"
                            >
                              <IonIcon icon={ticket}></IonIcon>
                            </IonBadge>
                          </>
                        )}
                      </div>{" "}
                    </div>
                  </div>
                </div> 
              </div>
            </div>
          </Link>
        </IonCard>
      ) : (
        <IonCard
          key={props.id}
          color="dark"
          className="infocard__cardwrapper"
          id={props.id}
          onMouseEnter={() => highlightMarker(props.id)}
          onMouseLeave={() => unhighlightMarker(props.id)}
        >

          {window.location.href.indexOf("typ=Entsorgungsstation") === -1 &&  target.indexOf("Eigenes Ziel: ") === -1  &&  (
              <>
                <a onClick={() => showModal(props.id)} className="infocard__bookmark">
                  <IonIcon
                      className="bookmark_active"
                      size="lg"
                      icon={bookmark}
                      color="medium"
                  />
                </a>
                <a onClick={() => showModal(props.id)} className="infocard__bookmark">
                  <IonIcon
                      className="bookmark_inactive"
                      size="lg"
                      icon={bookmarkOutline}
                      color="medium"
                  />
                </a>
              </>
          )}

          {target.indexOf("Eigenes Ziel: ") !== -1  &&  (
              <>
                <IonGrid>
                  <IonRow>

                    <IonCol size="12" className="infocard__content">
                      <h4 className="h4__bitter infocard__title">
                        {decode(props.name)}
                      </h4>
                    </IonCol>

                  </IonRow>
                </IonGrid>
              </>
          )}


          {target.indexOf("Eigenes Ziel: ") === -1  &&  (
              <>

          <Link
            target={`${
              window.location.hash == "#nosearch" ? "_blank" : "_self"
            }`}
            to={`${
              window.location.hash == "#nosearch"
                ? "/stellplatz/"
                : "/map/pitch/"
            }${props.slug}`}
          >
            <IonGrid>
              <IonRow>
                {props.url === "" ? (
                  <IonCol
                    className="infocard__background__image"
                    size="4"
                    style={{
                      background: `url('${window.config.wppath}/wp-content/uploads/2023/07/230620_Dolde_Schild_Muster_378x200px.jpg') no-repeat center`,
                    }}
                  ></IonCol>
                ) : (
                  <IonCol
                    className="infocard__background__image"
                    size="4"
                    style={{
                      background: `url('${props.url}') no-repeat center`,
                    }}
                  ></IonCol>
                )}

                <IonCol size="8" className="infocard__content">
                  <h4 className="h4__bitter infocard__title">
                    {decode(props.name)}
                  </h4>
                </IonCol>




                    <IonCol size="12" className="infocard__content">
                  <table className="infocard__table">
                    {typeof props.entsorgungsstation !== "undefined" && typeof props.entsorgungsstation.features !== "undefined" && props.entsorgungsstation.features.length !== 0  &&
                      props.entsorgungsstation.features.feature.map((item) => {
                        if (item.symbol === "l" || item.symbol === "k") {
                          return (
                            <tr>
                              <td
                                className={`font__icon infocard__icon_entsorgung infocard__table__left ${item.symbol}`}
                              >
                                {item.symbol}
                              </td>
                              <td className="infocard__table__right">
                                {" "}
                                {item.anmerkung}
                              </td>
                            </tr>
                          );
                        }
                      })}

                    {typeof props.entsorgungsstation !== "undefined" && props.entsorgungsstation.system.length !== 0 && (
                      <>
                        <span>System: {props.entsorgungsstation.system}</span><p></p>
                      </>
                    )}
                    {typeof props.entsorgungsstation !== "undefined" && props.entsorgungsstation.durchreise.length !== 0 && (
                      <>
                        <span>{props.entsorgungsstation.durchreise}</span>
                        <p></p>
                      </>
                    )}

                    <br />
                  </table>

                  <IonGrid className="padding__none">
                    <IonRow className="padding__none">
                      <IonCol
                        size="12"
                        size-md="12"
                        className="padding__none infocard__wrapper__distance"
                      >
                        <h5 className="h5_bitter infocard__heading">
                          {props.city}, {props.country}
                          {props.responseType === "default" && (
                            <>
                              <IonIcon icon={locationSharp} color="primary" />
                              {props.distance} km
                            </>
                          )}
                        </h5>
                      </IonCol>
                    </IonRow>
                  </IonGrid>
                </IonCol>




              </IonRow>
            </IonGrid>
          </Link>

              </>
          )}

        </IonCard>
      )}
    </div>
  );
}

export default InfoCard;
